import {
    UPLOAD_IMAGE_PROFILE_REQUEST,
    UPLOAD_IMAGE_PROFILE_SUCCESS,
    UPLOAD_IMAGE_PROFILE_FAILURE,
    UPLOAD_IMAGE_PROFILE
} from '../../actions/profile/upload-image-profile-actions';

const initialState = {
    data: {},
    isLoading: false,
    error: null,
};

const ProfileUploadImageReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPLOAD_IMAGE_PROFILE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case UPLOAD_IMAGE_PROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                upload: { ...action.payload },
            };
        case UPLOAD_IMAGE_PROFILE:
            return {
                ...state,
                isLoading: false,
                upload : { ...action.payload },
            }
        case UPLOAD_IMAGE_PROFILE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ProfileUploadImageReducer;